const Sommaire = {
    init() {
        if (window.innerWidth > 1040 && document.querySelector('.aside_single_post')) {
            const fixBodyOverflow = () => {
                document.body.style.setProperty('overflow-x', 'visible', 'important');
            };
            fixBodyOverflow();
            requestAnimationFrame(fixBodyOverflow);
            window.addEventListener('load', fixBodyOverflow);
        }

        const aside = document.querySelector('.aside_right_inner');
        if (!aside) return;

        if (window.innerWidth <= 1040) {
            const sommaire = document.querySelector('.wrapper_sommaire');
            const contentMain = document.querySelector('.single_content_main');
            if (sommaire && contentMain) {
                contentMain.parentNode.insertBefore(sommaire, contentMain);
            }

            const toggle = document.querySelector('.sommaire_toggle');
            if (toggle && sommaire) {
                const closeAccordion = () => {
                    sommaire.classList.remove('is-open');
                    toggle.setAttribute('aria-expanded', 'false');
                    toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open'));
                };

                toggle.addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    const isOpen = sommaire.classList.toggle('is-open');
                    toggle.setAttribute('aria-expanded', isOpen.toString());
                    toggle.setAttribute('aria-label', isOpen
                        ? toggle.getAttribute('data-label-close')
                        : toggle.getAttribute('data-label-open')
                    );
                });

                document.addEventListener('keydown', (evt) => {
                    if (evt.key === 'Escape' && sommaire.classList.contains('is-open')) {
                        closeAccordion();
                        toggle.focus();
                    }
                });

                sommaire.querySelectorAll('.sommaire_list a').forEach((link) => {
                    link.addEventListener('click', () => {
                        const targetId = link.getAttribute('href').replace('#', '');
                        const target = document.getElementById(targetId);
                        if (target) {
                            if (!target.hasAttribute('tabindex')) {
                                target.setAttribute('tabindex', '-1');
                            }
                            requestAnimationFrame(() => target.focus());
                        }
                    });
                });
            }
        }
    }
};

export default Sommaire;
